import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import css from './Security.module.css';

const securityItems = [
  'Interpres transmits data over public networks using strong encryption and supports the latest recommended secure cipher suites to encrypt data in transit, using transport layer security (TLS) 1.2 and above. This includes data transmitted between Interpres services, deployed infrastructure, and public endpoints.',
  'Internal vulnerability scans on the production environment on a continuous basis.',
  'Penetration tests on the production environment at least annually.',
  'Results of vulnerability scans and penetration tests are integrated into the development workflow to be addressed based on criticality.',
  'Annual SOC 2 examinations performed by an independent, third-party assessor.',
  'Access to production infrastructure is restricted via multi-factor authentication (MFA) and strict role-based access controls management supporting key principles of separation of duties, least privilege, and audit.',
  'Static application security testing (SAST) and dynamic application security testing (DAST) analysis tools are utilized to improve the security of the development process in the build pipeline.',
  'Production cloud infrastructure is hosted by a highly available cloud service provider covering multiple geographically diverse data center regions.',
  'Disk volumes, databases, and backups are safeguarded with encryption using industry best practices ciphers and key lengths for data at rest to prevent data access by unauthorized parties.',
  'Multiple monitoring solutions as well as monitoring tools built in-house are utilized to detect any issues with availability or performance and alert the appropriate personnel, who can then investigate any issues and take appropriate action.',
  'Interpres retains customer data as long as they continue to be active customers.',
  'Upon both termination of services provided to the customer, and upon request from the customer, Interpres will remove customer data from their systems.'
];

export const Security: FC = () => {
  return (
    <div className={css.container}>
      <Helmet>
        <title>Security</title>
        <meta
          name="description"
          content="CyberProof Interpres Security Standards"
        />
      </Helmet>

      <div className={css.content}>
        <div className={css.header}>
          <h1>CyberProof | Interpres Security Standards</h1>
        </div>

        <div className={css.body}>
          <h2 className={css.subheader}>
            CyberProof&apos;s Interpres application standardizes its principal
            security, availability, and confidentiality commitments, which
            include the following:
          </h2>
          <ul className={css.list}>
            {securityItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Security;
